export class TextSettings {
  constructor(overrides) {
    const defaults = {
      text: 'text',
      font: {
        fontSize: 14,
        fontSizeRem: '1.27rem',
        fontWeight: '600',
        color: '#22243b',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      languages: {}
    };
    Object.assign(this, defaults, overrides);
    if (overrides && overrides.font && overrides.font.fontSizeRem) {
      this.font.fontSize = overrides.font.fontSizeRem;
    }
  }
}
export const TextTypes = {
  text: {
    text: {
      title: 'Text',
      type: 'TextLanguageLimited'
    }
  },
  styles: {
    font: {
      title: 'Font',
      type: 'FontRem'
    }
  }
};